import script from "./MallHelpPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallHelpPage.vue?vue&type=script&setup=true&lang=ts"

import "./MallHelpPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__